import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

import StartTradingFtr from '@appComponents/bb-startTradingFooter';
import { CoinsList } from '@appComponents/bb-coinlistView';

import { SEO, MarkdownComponents } from '@components';

// import remark from 'remark';

const Articles = ({
	title,
	description,
	path,
	noIndex,
	heading,
	content,
}: {
	title: string;
	description: string;
	path: string;
	noIndex?: string;
	heading: string;
	content: string;
	// keyword,
}) => {
	const url = path.startsWith('/') ? `https://bitbns.com${path}` : path;

	return (
		<>
			<SEO
				title={title}
				description={description}
				robots={noIndex}
				url={url}
			/>
			<div className="bg-primary text-white py-8">
				<div className="container">
					<h1 className="font-bold text-center my-0 text-3xl">
						{heading}
					</h1>
				</div>
			</div>
			<div className="bg-white px-4 ">
				<div className="container py-16">
					<div className="mx-auto u-para--readable">
						<ReactMarkdown
							components={MarkdownComponents}
							remarkPlugins={[remarkGfm]}
							rehypePlugins={[rehypeRaw]}
						>
							{content}
						</ReactMarkdown>
					</div>
				</div>
			</div>
			<StartTradingFtr />
			<CoinsList buy price singleLine />
		</>
	);
};

export default Articles;
